import React from "react";

function IFrameDashboard({ iFrameContent }: { iFrameContent: string }) {
  return (
    <div
      id="looker-dashboard"
      dangerouslySetInnerHTML={{ __html: iFrameContent }}
    />
  );
}

export default IFrameDashboard;
